import React, {useState} from 'react';
import {FrontProps} from './tools/front-props';
import {createHook} from './tools/create-hook';
import {Root} from './components/root';

const appPropsHook = createHook((appProps: FrontProps) => appProps);
const AppPropsProvider = appPropsHook.provider;
export const useAppProps = appPropsHook.hook;


const modalsHook = createHook(() => {
    const [authModalOpen, setAuthModalOpen] = useState(false);
    const [votedWatchesModalOpen, setVotedWatchesModalOpen] = useState(false);

    return {
        authModalOpen,
        setAuthModalOpen,
        votedWatchesModalOpen,
        setVotedWatchesModalOpen,
    };
});

const snackbarHook = createHook(() => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'error' | 'success' | 'info' | 'warning'>('error');

    const showSnackbar = (message: string, severity: 'error' | 'success' | 'info' | 'warning' = 'error') => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const hideSnackbar = () => {
        setSnackbarOpen(false);
    };

    return {
        snackbarOpen,
        snackbarMessage,
        snackbarSeverity,
        showSnackbar,
        hideSnackbar,
    };
});
const ModalsHookProvider = modalsHook.provider;
export const useModals = modalsHook.hook;

const SnackbarHookProvider = snackbarHook.provider;
export const useSnackbar = snackbarHook.hook;

export const App: React.FC<{ props?: FrontProps }> = ({props}) => {
    // @ts-ignore
    return <AppPropsProvider initialValue={props || window.INITIAL_STATE}>
        <ModalsHookProvider>
            <SnackbarHookProvider>
                <Root/>
            </SnackbarHookProvider>
        </ModalsHookProvider>
    </AppPropsProvider>;
};

export default App;
